import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { interval, Subscription, take } from 'rxjs';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private refreshSubscription: Subscription | null = null;
  private readonly REFRESH_INTERVAL = 15 * 60 * 1000; // 15 minutes in ms

  constructor(
    private http: HttpClient,
    private state: StateService,
  ) { }

  getAuth() {
    return new Promise((Resolve) => {
      this.http
        .post<any>(
          environment.APICOMMON_URL + 'Authentication/AuthToken',
          {
            AppCode: environment.APP_ID,
            APIKEY: environment.API_KEY,
          },
          {
            observe: 'response',
          },
        )
        .pipe(take(1))
        .subscribe({
          next: (x: any) => Resolve(x),
          error: (error: HttpErrorResponse) => Resolve(error),
        });
    });
  }

  refreshTokenStart() {
    if (sessionStorage.getItem('user')) {
      if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
      }
      this.refreshSubscription = interval(this.REFRESH_INTERVAL).subscribe(
        () => {
          this.http
            .get(environment.APICOMMON_URL + 'Authentication/Refresh', {
              withCredentials: true,
            })
            .subscribe({
              next: (response: any) => {
                sessionStorage.setItem('auth', response.Token);
              },
              error: (error) => {
                this.logout();
                this.state.checkLogin();
                // handle error (maybe logout or retry)
              },
            });
        },
      );
    } else {
    }
  }

  refreshTokenStop() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
      this.refreshSubscription = null;
    }
  }

  checkTokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }

  login(UserName: string, password: string) {
    return new Promise((resolve) => {
      const maxRetries = 2;

      const tryGetAuth = (retryCount: number) => {
        this.getAuth().then((x: any) => {
          if (x?.ok) {
            sessionStorage.setItem('auth', x.body.Token);
            this.http
              .post(
                environment.APICOMMON_URL + 'Authentication/Login',
                {
                  UserName: UserName,
                  Password: password,
                  ApplicationCode: environment.APP_ID,
                },
                {
                  observe: 'response',
                  withCredentials: true,
                },
              )
              .pipe(take(1))
              .subscribe({
                next: (x: any) => {
                  resolve(x);
                },
                error: (error: HttpErrorResponse) => resolve(error),
              });
            return;
          }

          if (retryCount < maxRetries) {
            const nextRetry = retryCount + 1;
            console.log(`getAuth retry attempt ${nextRetry} of ${maxRetries}`);
            tryGetAuth(nextRetry);
            return;
          }

          this.state.Toast(
            false,
            'Following Error has occured:',
            'Auth Token fetch failed. Please try again.',
          );
          resolve(x?.error ?? x);
        });
      };

      tryGetAuth(0);
    });
  }

  redirectURL: string | null = null;
  logout() {
    sessionStorage.clear();
    window.location.pathname = '/login';
  }
}
